import { createListener } from '@state/store/createListener';
import { clearResults, performProductSearch, performSearch } from './dealFinderResultsSlice';

/* *************** *
 *   LISTENERS     *
 * *************** */
export const setupDealFinderResultsStateListeners = () => {
  createListener([performProductSearch.pending, performSearch.pending], async (_action, listenerApi) => {
    listenerApi.dispatch(clearResults());
  });
};
